import React from 'react';
import { Box, Card, CardContent, CardHeader, Divider, FormControlLabel, Switch, TextField } from '@material-ui/core';
import { useFormikContext } from 'formik';
import AsyncSearch from 'components/AsyncSearch';
import { ISettingsGroups } from '../interfaces';
import { getPositions, getUsers } from '../api';

interface IProps {
  disabled?: boolean;
}

const NPSSettings = ({ disabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<{ settings: ISettingsGroups }>();

  const {
    groupName,
    settings: [NPS_ENABLED_START, NPS_EXECUTOR_POSITION_ID, NPS_EXECUTOR_USER_ID],
  } = values.settings[1];

  const field = (index: number) => `settings[1].settings[${index}].value`;

  return (
    <Card>
      <CardHeader title={groupName} />
      <Divider />

      <CardContent component={Box} sx={{ display: 'flex', flexDirection: 'column', gridGap: 16 }}>
        <FormControlLabel
          disabled={disabled}
          control={
            <Switch
              color="primary"
              checked={NPS_ENABLED_START.value}
              onChange={(e) => setFieldValue(field(0), e.target.checked)}
            />
          }
          label={NPS_ENABLED_START.description}
        />

        <AsyncSearch
          value={NPS_EXECUTOR_POSITION_ID.value}
          fetch={getPositions}
          uniqueBy="positionId"
          matchKeys={['positionName']}
          onChange={(_, option) => setFieldValue(field(1), option)}
          disabled={disabled}
          getOptionLabel={(option) => String(option.positionName)}
          getOptionSelected={(option, value) => option.positionId === value.positionId}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label={NPS_EXECUTOR_POSITION_ID.description}
              placeholder="Выберите из списка"
            />
          )}
        />

        <AsyncSearch
          value={NPS_EXECUTOR_USER_ID.value}
          fetch={getUsers}
          remoteSearch
          uniqueBy="userId"
          matchKeys={['fullName']}
          onChange={(_, option) => setFieldValue(field(2), option)}
          disabled={disabled}
          getOptionLabel={(option) => String(option.fullName)}
          getOptionSelected={(option, value) => option.userId === value.userId}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label={NPS_EXECUTOR_USER_ID.description}
              placeholder="Выберите из списка"
            />
          )}
        />
      </CardContent>
    </Card>
  );
};

export default NPSSettings;
